var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195 111c-29-17-59-28-89-35S47 66 17 65v276c33 1 63 4 93 11 29 6 56 17 85 32V111zm3-17c8-22 20-40 35-54 20-21 45-34 66-40 4-1 8 2 10 6v51l39-6c17-1 34-2 50-2 5 0 8 3 8 8v292c0 5-3 9-8 9-35 0-67 3-98 10s-61 19-92 37c-2 1-4 2-7 1-1 0-2-1-3-1-31-18-61-30-92-37s-63-10-97-10H8c-4 0-8-4-8-9V57c0-5 4-8 8-8 34 0 68 3 101 11 31 7 60 18 89 34zm111-20v227c0 4-3 7-7 8-17 5-39 16-58 35-10 10-19 22-26 36 27-13 52-22 78-28 30-7 61-10 94-11V65c-14 1-27 1-40 3-14 1-27 3-41 6zm-65-23c-14 15-26 33-32 56v251c6-10 13-18 21-26 18-19 40-31 59-38V20c-15 6-33 16-48 31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/Docs.19311458d848ae9c932b1b32f5d8b626.svg";
export { ForwardRef as ReactComponent };